import { Logger } from '@aws-amplify/core';
import { isDevelopment } from './envUtil';

const logLevel = isDevelopment ? 'DEBUG' : 'WARN';
const logger = new Logger('EH', logLevel);

export default logger;
